import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierRemainsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierRemainsController.php
* @route '/api/dossier/update-remains/{dossier}'
*/
const UpdateDossierRemainsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierRemainsController.url(args, options),
    method: 'put',
})

UpdateDossierRemainsController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-remains/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierRemainsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierRemainsController.php
* @route '/api/dossier/update-remains/{dossier}'
*/
UpdateDossierRemainsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierRemainsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierRemainsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierRemainsController.php
* @route '/api/dossier/update-remains/{dossier}'
*/
UpdateDossierRemainsController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierRemainsController.url(args, options),
    method: 'put',
})

export default UpdateDossierRemainsController